import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgZorroAntdMobileModule} from 'ng-zorro-antd-mobile';
import {MatDialogModule} from '@angular/material';
import {PinchZoomModule} from 'ngx-pinch-zoom';
import {ImageCropperModule} from 'ngx-image-cropper';
import {DragDropModule} from "@angular/cdk/drag-drop";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgZorroAntdMobileModule,
    MatDialogModule,
    PinchZoomModule,
    ImageCropperModule,
    DragDropModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgZorroAntdMobileModule,
    MatDialogModule,
    PinchZoomModule,
    ImageCropperModule,
    DragDropModule
  ]
})
export class SharedModule {
}
